export const about = [
  <>
    A shiatsu gyökerei a <b>hagyományos kínai orvoslásig</b> nyúlnak vissza,
    amely az <b>életenergia</b>, azaz a Qi áramlását tartja az egészség
    alapjának. A 20. század elején <b>Tokujiro Namikoshi</b> fejlesztette ki. A
    test energetikai pontjait akupresszúrás technikákkal kezelte, és nagy
    hangsúlyt helyezett a <b>test természetes gyógyító képességeinek</b>{" "}
    serkentésére.
  </>,

  <>
    A shiatsu terápia alapját a meridiánrendszer és az energetikai egyensúly
    helyreállítása adja. A meridiánok olyan <b>energiacsatornák</b>, amelyek a
    testet behálózva szállítják az <b>életenergiát</b> (Qi). Ha ezek a csatornák
    blokkolódnak vagy az energiaáramlás zavart szenved, az{" "}
    <b>fizikai és mentális problémákat okozhat</b>.
  </>,
];
export const during = [
  <>
    A bowen kezeléssel <b>kombinálva</b> növeli a testi és lelki diszfunkciók
    korrigálását
  </>,
  <>
    Izmokra, ízületekre és a test <b>energiapontjaira</b> és{" "}
    <b>meridiánjaira</b> is összpontosul a figyelem
  </>,
  <>Matracon vagy masszázs ágyon könnyű, laza ruházatban</>,
  <>
    Statikus nyomás: Az <b>energiapontok</b> finom, hosszantartó <b>nyomása</b>
  </>,
  <>
    Mozgásos technikák: <b>nyújtás, forgatás és lazítás</b> a testmozgás
    segítségével
  </>,
  <>
    A légzés és érintés <b>összehangolásával</b> mélyebb ellazulás érhető el
  </>,
];
export const usefulForExtra = (
  <>
    <p>
      A shiatsu <b>természetes módon</b> segít kezelni a{" "}
      <b>stresszt, a fáradtságot</b>.<br />
      Különösen hatékony a következő esetekben:
    </p>
  </>
);
export const usefulFor = [
  [<>Krónikus hát- és derékfájás</>, <>Fejfájás, migrén</>],
  [<>Stressz</>, <>Szorongás</>],
  [<>Alvászavarok</>, <>Emésztési problémák</>],
];
